import { render, staticRenderFns } from "./ExtraPageEditor.vue?vue&type=template&id=69d1ac2a&scoped=true&"
import script from "./ExtraPageEditor.vue?vue&type=script&lang=ts&"
export * from "./ExtraPageEditor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69d1ac2a",
  null
  
)

export default component.exports